module.exports = __webpack_public_path__ + "static/media/GK.36854a06.png";